export * from './shadow-type-5.component';